import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Button, Card, Container, TabContent, TabPane } from "reactstrap";
import TreeView from "../../treeView";
import SubServicesTable from "../../subServicesTable";
import ServiceForm from "../serviceForm";
import NewServiceForm from "../serviceForm copy"

import ServiceDetailCard from "./serviceDetailCard";

const TabComponent = ({ activeTab, reloadExt }) => {
  const serviceForm = useRef();
  const [reload, setReload] = useState(false);

  const submitForm = async () => {
    try {
      await serviceForm.current.handleSubmit();
      setReload(!reload);
    } catch (err) {}
  };

  useEffect(() => {
    setReload(!reload);
  }, [reloadExt]);
  return (
    <Fragment>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <TreeView reload={reload} type={"Services"} />
        </TabPane>
        <TabPane tabId="2">
          <Container fluid={true}>
            <ServiceDetailCard />
          </Container>
        </TabPane>
        <TabPane tabId="3">
          <Card className="p-4">
            <ServiceForm ref={serviceForm} formType="edit"></ServiceForm>
            <Button className="mt-4 bg-primary" onClick={() => submitForm()}>
              Update
            </Button>
          </Card>
        </TabPane>
        <TabPane tabId="5">
          <Card className="p-4">
            <NewServiceForm ref={serviceForm} formType="edit"></NewServiceForm>
            <Button className="mt-4 bg-primary" onClick={() => submitForm()}>
              Update
            </Button>
          </Card>
        </TabPane>
        {/* <TabPane tabId="4">
          <SubServicesTable />
        </TabPane> */}
      </TabContent>
    </Fragment>
  );
};

export default TabComponent;
